/* src/app/modals/guest-count-modal/guest-count-modal.component.scss */
.sheet {
  --background: #222;
  text-align: center;
}
.close-btn {
  --border-style: none !important;
}
.title {
  margin: 2rem 0 1rem;
  font-size: 1rem;
  font-weight: 700;
  color: #4fc3f7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.4;
}
.scroll-container {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding: 20px 40px;
  scrollbar-width: none;
}
.num {
  flex: 0 0 auto;
  width: 70px;
  scroll-snap-align: center;
  font-size: 2.2rem;
  margin: 0 16px;
  color: #888;
  transition: transform 0.2s, color 0.2s;
  cursor: pointer;
  text-align: center;
}
.num.active {
  color: #4fc3f7;
  transform: scale(2);
  font-weight: bold;
}
.pad {
  flex: 0 0 auto;
  width: 50%;
}
/*# sourceMappingURL=guest-count-modal.component.css.map */
